import { Box, Hidden, styled } from "@material-ui/core";
import React from "react";
import { OilCoversFragment_covers } from "./__generated__/OilCoversFragment";
import Imgix from "react-imgix";

const PriceLabel = styled("span")(({ theme }) => ({
  fontSize: "2.8rem",
  lineHeight: "2.8rem",
  letterSpacing: "0px",
  fontFamily: "Reckless",
  fontWeight: 600,
  position: "absolute",
  bottom: "8px",
  left: "8px",
  zIndex: 100,
  userSelect: "none",
  color: "currentColor",
  [theme.breakpoints.down("xs")]: {
    letterSpacing: "-0.5px",
    fontSize: "1.8rem",
    lineHeight: "1.8rem"
  }
}));

const OilType = styled("span")(({ theme }) => ({
  fontSize: "1.6rem",
  lineHeight: "1.6rem",
  textTransform: "uppercase",
  letterSpacing: "0.25px",
  fontFamily: "Reckless",
  fontWeight: 600,
  position: "absolute",
  bottom: "8px",
  right: "8px",
  zIndex: 100,
  userSelect: "none",
  maxWidth: "80px",
  textAlign: "end",
  color: "currentColor",
  [theme.breakpoints.down("xs")]: {
    fontSize: "1rem",
    lineHeight: "1rem"
  }
}));

const Image = styled("img")(() => ({
  width: `100%`,
  height: `100%`,
  borderRadius: "3px",
  position: "absolute",
  top: 0,
  left: 0
}));

export type OilCoverSize = "normal" | "small";

type OilCoverProps = OilCoversFragment_covers & {
  size?: OilCoverSize;
};

export function getCoverWidthHeight(size?: OilCoverSize) {
  switch (size) {
    case "normal":
      return { xs: 160, sm: 240 };
    case "small":
      return { xs: 96, sm: 144 };
    default:
      return { xs: 160, sm: 240 };
  }
}

export function getCoverMargin(size?: OilCoverSize) {
  switch (size) {
    case "normal":
      return { xs: 2, sm: 4 };
    case "small":
      return { xs: 0.75, sm: 2 };
    default:
      return { xs: 2, sm: 4 };
  }
}

export default function OilCover({
  image,
  priceLabel,
  oilType,
  textColor,
  size
}: OilCoverProps) {
  const widthHeight = getCoverWidthHeight(size);
  const margin = getCoverMargin(size);
  const { url } = image;

  return (
    <Box
      width={widthHeight}
      height={widthHeight}
      flexShrink={0}
      mr={margin}
      position="relative"
      style={{ color: textColor || "white" }}
    >
      <PriceLabel>{priceLabel}</PriceLabel>
      <OilType>{oilType}</OilType>
      <Hidden smUp>
        <Imgix
          src={url}
          width={widthHeight.xs}
          height={widthHeight.xs}
          imgixParams={{
            ar: "1",
            fit: "crop",
            auto: "format,compress"
          }}
        />
      </Hidden>
      <Hidden xsDown>
        <Imgix
          src={url}
          width={widthHeight.sm}
          height={widthHeight.sm}
          imgixParams={{
            ar: "1",
            fit: "crop",
            auto: "format,compress"
          }}
        />
      </Hidden>
    </Box>
  );
}
